module.exports = __webpack_public_path__ + "static/media/guys-compiling.f6e0bf30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intros/guys-compiling.png
// module id = 969
// module chunks = 0